import React, { useState } from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';

import Router from './router/router.jsx';
import { AuthProvider, useAuth } from './contexts/AuthContext/AuthContext.jsx';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: 'transparent',
          background: 'linear-gradient(180deg, #A05EB5 1%, #00B5E2 80%, #6CC04A 100%)',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        },
        // Markdown Styles
        'h1, h2, h3, h4, h5, h6': {
          fontFamily: 'inherit',
          fontWeight: 600,
          lineHeight: 1.2,
          margin: '1.5rem 0 1rem 0',
        },
        'h1': {
          fontSize: '1.8rem',
          color: '#000000',
          borderBottom: 'none',
          paddingBottom: '0',
        },
        'h2': {
          fontSize: '1.375rem',
          color: '#000000',
          borderBottom: 'none',
          paddingBottom: '0',
        },
        'h3': {
          fontSize: '1.125rem',
          color: '#424242',
        },
        'h4': {
          fontSize: '1rem',
          color: '#424242',
        },
        'h5': {
          fontSize: '0.875rem',
          color: '#424242',
        },
        'h6': {
          fontSize: '0.75rem',
          color: '#666666',
        },
        'p': {
          fontSize: '1rem',
          lineHeight: 1.6,
          color: '#333333',
          margin: '0.75rem 0',
        },
        'ul, ol': {
          margin: '0.75rem 0',
          paddingLeft: '2rem',
        },
        'li': {
          margin: '0.25rem 0',
          lineHeight: 1.5,
        },
        'ul li': {
          listStyleType: 'disc',
        },
        'ol li': {
          listStyleType: 'decimal',
        },
        'pre': {
          backgroundColor: 'transparent',
        },
        'blockquote': {
          borderLeft: '4px solid #1976d2',
          backgroundColor: '#f8f9fa',
          margin: '1rem 0',
          padding: '0.75rem 1rem',
          fontStyle: 'italic',
          color: '#555555',
        },
        'blockquote p': {
          margin: 0,
        },
        'table': {
          borderCollapse: 'collapse',
          width: '100%',
          margin: '1rem 0',
        },
        'th': {
          color: 'white',
          fontWeight: 600,
          padding: '0.75rem',
          textAlign: 'left',
        },
        'td': {
          padding: '0.75rem',
          verticalAlign: 'top',
        },
        'a': {
          color: '#1976d2',
          textDecoration: 'none',
          fontWeight: 500,
        },
        'a:hover': {
          color: '#1565c0',
          textDecoration: 'underline',
        },
        'strong': {
          fontWeight: 700,
          color: '#333333',
        },
        'em': {
          fontStyle: 'italic',
          color: '#555555',
        },
        'del': {
          textDecoration: 'line-through',
          color: '#999999',
        },
        'hr': {
          border: 'none',
          borderTop: '2px solid #e0e0e0',
          margin: '2rem 0',
        },
        'img': {
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '4px',
          margin: '1rem 0',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});


function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
